/**
 * Thin fetch wrapper for the timetable API.
 *
 * The base URL points at the `course-management/timetable-api` route (without an
 * action). The action segment + HTTP method select the controller action
 * (e.g. `events` + POST => eventsPostAction).
 */

async function request(baseUrl, action, method, payload) {
	const url = `${baseUrl.replace(/\/$/, "")}/${action}`;
	const response = await fetch(url, {
		method,
		headers: {
			"Content-Type": "application/json",
			Accept: "application/json",
			"X-Requested-With": "XMLHttpRequest",
		},
		credentials: "include",
		body: method === "GET" ? undefined : JSON.stringify(payload ?? {}),
	});

	let data = {};
	try {
		data = await response.json();
	} catch {
		// no-op: keep empty object
	}

	if (!response.ok || data.error || data.invalid) {
		const error = new Error(data.error || `HTTP ${response.status}`);
		error.response = data;
		throw error;
	}

	return data;
}

// The shape the conflict endpoint reports when nothing (or no valid range) matched.
export const EMPTY_CONFLICT_SUMMARY = { room: 0, lecturer: 0, cohort: 0, total: 0 };

export const fetchFilterOptions = async (baseUrl) => {
	const data = await request(baseUrl, "filter-options", "GET");

	return data.options ?? {};
};

export const fetchEvents = async (baseUrl, payload) => {
	const data = await request(baseUrl, "events", "POST", payload);

	return data.events ?? [];
};

export const fetchConflicts = async (baseUrl, payload) => {
	const data = await request(baseUrl, "conflicts", "POST", payload);

	return {
		conflicts: data.conflicts ?? [],
		summary: data.summary ?? { ...EMPTY_CONFLICT_SUMMARY },
	};
};
